import { Controller } from "@hotwired/stimulus"
import { postJson } from "./news_api"

// キーワードに対する2つの指定。★お気に入り（前に出す）と 興味なし（後ろに下げる）。
// 片方を付けたらもう片方は外れる（サーバー側でも同じことをしている）。
export default class extends Controller {
  static values = {
    topicId: Number,
    favorited: Boolean,
    muted: Boolean,
    loginPath: { type: String, default: "/login" },
    // マイページの一覧では、取り消したその場で消えないと「消えていない」と読まれる
    removeOnClear: Boolean
  }
  static targets = ["favorite", "mute", "note"]

  connect() {
    this.connected = true
  }

  toggleFavorite(event) {
    event.preventDefault()
    const on = this.favoritedValue
    this.#send(`/news/topic_favorites/${this.topicIdValue}`, on ? "DELETE" : "POST")
  }

  toggleMute(event) {
    event.preventDefault()
    const on = this.mutedValue
    this.#send(
      `/news/topic_preferences/${this.topicIdValue}`,
      on ? "DELETE" : "PUT",
      on ? null : { stance: "down" }
    )
  }

  // 押した直後に見た目を変えるのではなく、**返ってきた値で塗る**
  // （失敗したのに付いたように見えるのを避ける）
  async #send(url, method, body = null) {
    if (this.busy) return
    this.busy = true
    try {
      const data = await postJson(url, { method, body, loginPath: this.loginPathValue })
      if (!data || data.ok === false) return
      if ("favorited" in data) this.favoritedValue = data.favorited
      if ("muted" in data) this.mutedValue = data.muted
    } catch (e) {
      console.error("topic interest update failed", e)
    } finally {
      this.busy = false
    }
  }

  favoritedValueChanged() { this.#render() }
  mutedValueChanged() { this.#render() }

  #render() {
    if (this.removeOnClearValue && this.connected && !this.favoritedValue && !this.mutedValue) {
      const chip = this.element.closest("[data-topic-chip]")
      ;(chip || this.element).remove()
      return
    }
    this.#paint(this.hasFavoriteTarget ? this.favoriteTarget : null, this.favoritedValue, "bg-amber-500")
    this.#paint(this.hasMuteTarget ? this.muteTarget : null, this.mutedValue, "bg-gray-600")
    if (this.hasNoteTarget) {
      this.noteTarget.textContent =
        this.favoritedValue ? "このキーワードを正面に出します" :
        this.mutedValue     ? "このキーワードを後ろに下げます（消しません）" :
                              "お気に入りにすると、次からトップの並びで前に出ます"
    }
  }

  #paint(el, on, activeClass) {
    if (!el) return
    el.setAttribute("aria-pressed", on ? "true" : "false")
    el.classList.toggle(activeClass, on)
    el.classList.toggle("text-white", on)
    el.classList.toggle("bg-gray-100", !on)
    el.classList.toggle("dark:bg-gray-800", !on)
  }
}
